import React from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { useEntityList } from '../../data/entities';
import WorkspaceDevSpaces from '../../components/WorkspaceDevSpaces';

// Dev Studio module (org-wide view): dev spaces grouped by workspace. Select
// a project in the sidebar for the scoped view.
export default function DevStudioModule() {
  const { org } = useOutletContext();
  const { docs: workspaces } = useEntityList('workspace', { org: org.id });

  return (
    <div data-nova-note="Dev Studio: VS Code in the browser on isolated Fargate tasks, one per workspace, datasets mounted. Starting and stopping a studio is the person's click; NoVA explains and navigates (navigate_app).">
      <h1 style={{ margin: 0 }}>Dev Studio</h1>
      <p className="cs-help" style={{ marginTop: 6 }}>
        VS Code in the browser on isolated Fargate tasks — datasets mounted at{' '}
        <code>~/datasets</code>, auto-stops after the runtime cap.
      </p>
      {workspaces && !workspaces.length && (
        <div className="cs-empty" style={{ marginTop: 16 }}>No workspaces yet.</div>
      )}
      {(workspaces || []).map((ws) => (
        <section key={ws.id} style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
            <h2 style={{ margin: 0, fontSize: 18 }}>{ws.name}</h2>
            <Link to={`/orgs/${org.id}/ws/${ws.id}`} className="cs-help" style={{ fontSize: 12 }}>
              open workspace →
            </Link>
          </div>
          <WorkspaceDevSpaces orgId={org.id} workspaceId={ws.id} compact />
        </section>
      ))}
    </div>
  );
}
